<template>
  <ul
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-20 lg:gap-y-40 xl:gap-y-50"
  >
    <slot />
  </ul>
</template>
